/**
 * TODO: This function is used to get the bredcumb name
 * @param \\ path -> landing-pages
 * @return `Landing pages`
 */
const getBredCumbName = (path: string) => {
  // Split the input text by hyphen
  const words = path.split('-');

  // Capitalize the first letter of each word after the first one
  const bredCumbName =
    words[0] +
    words
      .slice(1)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');

  if (path === 'admin') return 'home';

  return bredCumbName;
};

export default getBredCumbName;
